<template>
  <button @click="buttonClick" :class="['btn', size]">
    <slot />
  </button>
</template>

<script>
export default {
  name: "w-button",
  props: {
    title: {
      type: String,
    },
    size: {
      type: String,
      default: "larg",
    },
  },
  methods: {
    buttonClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  font-size: 20.3755px;
  line-height: 29px;
  width: 194px;
  height: 48px;
  background: linear-gradient(135deg, #d3be8c 0%, #c2a061 100%);
  border-radius: 3.13469px;
  color: #ffffff;
  border-radius: 5px;
  cursor: pointer;
  border: none;

  @media screen and(max-width: 450px) {
    width: 120px;
    height: 48px;
  }
  &.larg {
    width: 100%;
  }
}
</style>
